import { useSelector } from "react-redux";
import { getParamValue } from "utils/rcUtils";

const useRemoteConfig = (param, group = "imtime") => {
  const { config } = useSelector((state) => state.remote);

  return getParamValue(config, param, group);
};

export default useRemoteConfig;
